<template>
  <v-container class="margen_paginas pt-7" fluid>
    <!-- indicador de espera de comunicaciones -->
    <v-overlay 
      v-model="activarIndicadorEspera" 
      z-index= "999999"> <!-- por encima de todas las ventanas -->
      <v-progress-circular  
        size="120"
        width="12"                       
        color="red"
        indeterminate
        justify="center" 
        align="center">
      </v-progress-circular>
    </v-overlay> 

    <v-row no-gutters>
      <v-col>
        <v-card style="padding:20px;">


          <!-- 1ª linea: listados -->
          <v-row>

            <!-- columna izq: lista de descuentos disponibles -->
            <v-col>
              <v-data-table
                  class="elevation-5"
                  v-model="seleccionados"
                  :items="descuentos"
                  :items-per-page="10"
                  :headers="cabecerasDescuentos"
                  :hide-default-footer="true"
                  :single-select="!singleSelect"
                  show-select >

                <!-- titulo -->
                <template v-if="titulo" v-slot:top>     
                  <v-toolbar dense flat color="#b0b0c0">
                    <v-toolbar-title>
                        <v-icon v-if="icono" class="mt-n1 mr-1">{{icono}}</v-icon>
                        {{titulo}}
                    </v-toolbar-title>
                  </v-toolbar>
                </template>
              </v-data-table>
            </v-col>

            <!-- columna der: lista de ultimas operaciones realizadas -->
            <v-col>
              <v-data-table
                  class="elevation-5"
                  :items="ultimasOperaciones"
                  :items-per-page="10"
                  :headers="cabecerasHistorico"
                  :hide-default-footer="true">

                <!-- titulo -->
                <template v-if="titulo" v-slot:top>     
                  <v-toolbar dense flat color="#b0b0c0">
                    <v-toolbar-title>
                        <v-icon v-if="icono" class="mt-n1 mr-1">mdi-calendar-clock</v-icon>
                        Últimos descuentos aplicados
                    </v-toolbar-title>
                  </v-toolbar>
                </template>
              </v-data-table>
            </v-col>  
          </v-row>

          <!-- 2ª linea: entrada de datos de estancia -->
          <v-row>
            <v-col>
              <!-- mostrar mensaje de error de comunicaciones/descuento no seleccionado -->
              <template v-if="alertaDescuentos.mostrar" > 
                  <v-alert
                        :value="alertaDescuentos.mostrar"
                        :color="alertaDescuentos.color"
                        dark
                        border="top"
                        :icon="alertaDescuentos.icono"
                        transition="scale-transition"
                  >
                    {{ this.alertaDescuentos.texto }}
                  </v-alert>     
              </template>

              <!-- mostrar formulario de introduccion de datos -->
              <template v-else>

                <v-row>

                  <!-- columna izq: camara -->
                  <v-col> 
                    <StreamBarcodeReader 
                      @decode="onDecode"
                    ></StreamBarcodeReader>              
                  </v-col> 

                  <!-- columna der: entrada de texto -->
                  <v-col>
                    <v-form @submit.prevent="handleSubmit" v-model="formularioValido">
                      <div class="form-group entradaDatosUnico">
                        <!-- para mostrar resultado de la asignacion del descuento -->
                        <v-alert style="margin-bottom:10px;"
                              :value="resultadoVinculacion.mostrar"
                              :color="resultadoVinculacion.color"
                              dark
                              border="top"
                              :icon="resultadoVinculacion.icono"
                              transition="scale-transition"
                        >
                          {{ this.resultadoVinculacion.texto }}
                        </v-alert> 
                        <v-icon v-if="icono" class="mt-n1 mr-1">mdi-car</v-icon>
                        <label for="itemABuscar">Introduzca la matrícula, nº de ticket o escanee el código de barras</label>
                        <v-text-field
                              v-model="itemABuscar" 
                              append-icon='mdi-keyboard-return'
                              id="itemABuscar" name="itemABuscar" ref="itemABuscar"
                              v-inputfilter="{ mayusculas: true, expresionRegular: ['[^0-9A-Za-z]', 'g'], longitudMaxima: 69, longitudMinima: 6}"
                              clearable 
                              dense
                              autofocus
                              :rules="reglasValidacion"
                              @click:append="handleSubmit"
                              @keydown="setReglasValidacion"
                        />
                      </div>
                    </v-form> 

                  </v-col>
                </v-row>              

              </template>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

// comunicacion HTTP con RestApi
import axios from "axios"
import { URL_BASE_API } from '@/api.js'

import {StreamBarcodeReader}  from "vue-barcode-reader"

export default {
  components: { StreamBarcodeReader },
  watch: {
    // al cambiar el array seleccionados se activa esta funcion
    seleccionados: function () {
      if (0 == this.seleccionados.length){
        this.alertaDescuentos.mostrar = true;
        this.alertaDescuentos.texto = "Seleccione un descuento para continuar";
        return;    
      } else {
        this.alertaDescuentos.mostrar = false;
      }
    }
  }, // fin watch


  data: () => ({
      // ventana de aviso de errores de comunicación al obtener la lista de descuentos
      alertaDescuentos: {
          mostrar: false,
          color: 'blue',
          texto: 'Seleccione un descuento para continuar',
          icono: 'mdi-information-variant'
      }, //fin objeto alertaDescuentos
      
      // ventana de aviso de resultado de la vinculacion de descuento
      resultadoVinculacion: {
          mostrar: false,
          asignado: false,
          color: 'green',
          texto: '',
          icono: 'mdi-check'
      }, //fin objeto resultadoVinculacion

      // control de la visualizacion del indicador de espera 
      activarIndicadorEspera: false,

      // control de la visualizacion del dialogo de entrada de ticket/matricula 
      entradaTicket: false,

      //reglas de validacion de formulario
      reglasValidacion: [],
      formularioValido: false,

      // ticket/matricula al que vincular el descuento
      itemABuscar: undefined,      

      // cabeceras de datos a mostrar en la tabla
      cabecerasDescuentos: [
        { text: 'Descripción', value: 'descripcion', align: 'start', sortable: false},
      ], // fin objeto cabecerasDescuentos

      // cabeceras de datos a mostrar en la tabla de ultimas operaciones
      cabecerasHistorico: [
        { text: 'Fecha', value: 'fecha', align: 'start', sortable: false},
        { text: 'NºProducto', value: 'producto', align: 'start', sortable: false},
        { text: 'Matrícula', value: 'matricula', align: 'start', sortable: false},
      ], // fin objeto cabecerasHistorico

      // cada uno de los descuentos vinculables obtenidos del parking
      descuentos: [
      ], // fin objeto datos descuentos 
      
      // descuentos seleccionados en un momento dado
      seleccionados: [
      ], // fin array descuentos seleccionados 

      ultimasOperaciones:[
      ],

      // Configuracion de la tabla de descuentos
      singleSelect: false,
      titulo: "Descuentos disponibles",
      icono: "mdi-percent",

  }), // fin objeto data
  

  methods: {

    cerrarMensajeVinculacionOk: function(){
      this.resultadoVinculacion.mostrar = false;
      
      // la configuracion indica que se borren los descuentos seleccionados tras su aplicacion
      if (1 == this.$store.state.operador.empresaInquilina.borrarDescuentos) {
        this.seleccionados=[];   
      }

    }, // fin metodo cerrarMensajeVinculacionOk   
    
    setReglasValidacion: function(){
      this.reglasValidacion= [
        value => (!!value ) || 'No puede estar vacio',
        value => (value && value.length >= 6) || '6 caracteres como mímino',
      ];
    }, // fin metodo setReglasValidacion

    handleSubmit: function() {
      /* comprobacion de que los datos del formulario son correctos 
        antes de continuar con el proceso de vincular el descuento */
      this.resultadoVinculacion.mostrar = false;

      // stop here if form is invalid
      if (!this.formularioValido) {
        return;
      }

      this.activarIndicadorEspera = true;

      console.log('Consulta vincularDescuentos');
      /* OJO como la variable datosPeticion no incluye la clave product_group_codes,
         el backend asignará el descuento en el parking utilizando el endpoint
         discounts_v2 en lugar de attachments; de esta forma podremos obtener informes
         de SAGA */
      var datosPeticion = {
        'codinsclo': this.$store.state.operador.instalacion.codinsclo,
        'txtProducto': encodeURIComponent(this.itemABuscar),
        'descuentos': this.seleccionados,
        'operador': this.$store.state.operador,
      };
      console.log(datosPeticion);

      const cabeceras = {
        'Content-Type': 'application/json; charset=windows-1252'
      };

      axios
        .post( URL_BASE_API + '/EPCloud/vincularDescuentos',  
              datosPeticion,
              {headers: cabeceras}
        )
        .then(response => {
          console.log('Respuesta vincularDescuentos');
          console.log(response);

          this.activarIndicadorEspera = false;
          var unaOperacion = {};

          if (0 == response.data.error){
            this.reglasValidacion= [];
            this.itemABuscar = '';

            unaOperacion.fecha = new Date().toLocaleString();
            unaOperacion.producto = response.data.producto;
            unaOperacion.matricula = response.data.matricula;
            unaOperacion.resultado = 'OK'
            
            this.resultadoVinculacion.mostrar = true;
            this.resultadoVinculacion.asignado = "true";
            this.resultadoVinculacion.color = "green";
            this.resultadoVinculacion.icono = "mdi-check";
            this.resultadoVinculacion.texto = "Descuento aplicado correctamente";

            setTimeout(this.cerrarMensajeVinculacionOk,3000);

          } else {
            this.resultadoVinculacion.mostrar = true;
            this.resultadoVinculacion.color = "red";
            this.resultadoVinculacion.icono = "mdi-exclamation";
            this.resultadoVinculacion.texto = response.data.error_txt;

            unaOperacion.fecha = new Date().toLocaleString();
            unaOperacion.producto = response.data.error_txt;
            unaOperacion.matricula = '';
            unaOperacion.resultado = 'KO'
          }

          if (6 == this.ultimasOperaciones.length) {
            this.ultimasOperaciones.splice(0, 1);
          }

          this.ultimasOperaciones.push(unaOperacion);

        })
        .catch(error => {
            console.log('Error vincularDescuentos')
            console.log(error);

          this.activarIndicadorEspera = false;
          this.resultadoVinculacion.mostrar = true;
          this.resultadoVinculacion.color = "red";
          this.resultadoVinculacion.icono = "mdi-exclamation";
          this.resultadoVinculacion.texto = error;
      
        })
        .finally(() => { 
          console.log('Final vincularDescuentos');
        })

    }, // fin metodo handleSubmit

    onDecode (result) {
      this.itemABuscar = result;
      console.log(result)
    }, // fin metodo onDecode   

  }, // fin methods

  mounted () {
    console.log(this.$store.state.operador);

    /* segun la configuracion de la empresa inquilina, permito seleccionar 
       varios descuentos simultáneos o no */
    this.singleSelect = this.$store.state.operador.empresaInquilina.multiplesDescuentos;




    /* A partir de aquí, proceso de comprobacion de que los descuentos permitidos siguen existiendo
       en el parking */
    
    var favoritoBD = [];
    var descuentosPermitidos = [];
    
    // descuentos almacenados en la base de datos
    var descuentosPermitidosBD = 
                JSON.parse(this.$store.state.operador.empresaInquilina.descuentosPermitidos);

    // descuentos recibidos del parking tras el login
    var descuentosVinculables = 
                JSON.parse(localStorage.getItem ('descuentos_vinculables'));

    for (var indice in descuentosPermitidosBD) {
      /* busca el id-descuento almacenado en la base de datos en el array de descuentos 
          vinculables recibidos del parking */
      const resultado = descuentosVinculables.find( 
                            descuento => descuento.id === descuentosPermitidosBD[indice].id
                        );

      if (undefined != resultado){
        // existe el id
        if ((resultado.descripcion == descuentosPermitidosBD[indice].descripcion) &&
            (resultado.type == descuentosPermitidosBD[indice].type) &&
            (resultado.value == descuentosPermitidosBD[indice].value)){
          // es el mismo descuento
          descuentosPermitidos.push(descuentosPermitidosBD[indice]);   

          // busca el descuento favorito en el array de descuentos permitidos
          if (this.$store.state.operador.empresaInquilina.descuentoFavorito == descuentosPermitidosBD[indice].descripcion){
            favoritoBD.push(descuentosPermitidosBD[indice]);
          }

        } else {
          console.log('El descuento difiere');         
          console.log(resultado);
          console.log(descuentosPermitidosBD[indice]);       
        }


      }
    }

    if (descuentosPermitidos.length != descuentosPermitidosBD.length){
      this.descuentos = []
      //this.seleccionados=[];        
      
      this.alertaDescuentos = {
          mostrar: true,
          asignado: false,
          color: 'red',
          texto: 'Alguno de los descuentos que estaban permitidos ya no existen. Consulte con el administrador del parking.',
          icono: 'mdi-exclamation'
      }; 
    
    
    } else {
      this.descuentos = JSON.parse(this.$store.state.operador.empresaInquilina.descuentosPermitidos);
      this.seleccionados = favoritoBD;        
    }

  } // fin mounted
};
</script>

<style scoped>

  .entradaDatosUnico {
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 20px;
  }

  .iconoInfo{
    color:#1A55F4; 
    margin-right: 10px;
  }
</style>